'use client';

import { memo } from 'react';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

export const SearchCategoriesSkeleton: ComponentMemo = memo(() => {
    return (
        <>
            <GlowSkeleton width={'80%'} height={'2rem'} containerClassName={'w-full'} />
            <GlowSkeleton width={'100%'} height={'2rem'} containerClassName={'w-full'} />
        </>
    );
});

SearchCategoriesSkeleton.displayName = 'SearchCategoriesSkeleton';
